import _regeneratorRuntime from "/opt/render/project/src/intelliflight/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/render/project/src/intelliflight/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/opt/render/project/src/intelliflight/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/render/project/src/intelliflight/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/render/project/src/intelliflight/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/render/project/src/intelliflight/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/render/project/src/intelliflight/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import './style.css';
var proxyUrl = "https://cors-anywhere.herokuapp.com/";
export var GoogleComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(GoogleComponent, _Component);

  function GoogleComponent(props) {
    var _this;

    _classCallCheck(this, GoogleComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GoogleComponent).call(this, props));
    _this.state = {
      collection: null,
      collectionShow: false,
      place: '',
      allowCountry: '',
      location: '',
      returnData: {},
      currentLocation: '',
      currentCoordinates: {},
      liStyle: '',
      proxyUrl: " "
    };
    return _this;
  }

  _createClass(GoogleComponent, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _ico, _current;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setState({
                  liStyle: this.props.locationListStyle ? this.props.locationListStyle : 'style-list'
                });

              case 2:
                _ico = React.createElement("img", {
                  className: 'current-loc-ico',
                  src: "https://www.materialui.co/materialIcons/maps/my_location_black_192x192.png"
                });
                _current = React.createElement("li", {
                  className: this.state.liStyle,
                  onClick: function onClick() {
                    return _this2.getCurrentLocation();
                  }
                }, _ico, "Current Location");
                this.setState({
                  currentLocation: _current
                });
                document.addEventListener("mousedown", function (e) {
                  return _this2.handleClickOutside(e);
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      document.removeEventListener("mousedown", function (e) {
        return _this3.handleClickOutside(e);
      });
    }
  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.setState({
          collectionShow: false
        });
      }
    }
  }, {
    key: "getInfo",
    value: function getInfo(param) {
      var _this4 = this;

      var child = [];

      var _co = this.props.country ? 'components=' + this.props.country + '&' : '';

      var _lang = this.props.language ? 'language=' + this.props.language + '&' : '';

      if (this.props.apiKey) {
        var _fire = fetch(this.state.proxyUrl + 'https://maps.googleapis.com/maps/api/place/autocomplete/json?input=' + param + '&' + _lang + _co + '&key=' + this.props.apiKey);

        _fire.then(function (dataJson) {
          return dataJson.json().then(function (data) {
            if (data.status == "OK" && data.predictions.length > 0) {
              var _loop = function _loop(loc) {
                child.push(React.createElement("li", {
                  key: loc,
                  className: _this4.state.liStyle,
                  onClick: function onClick() {
                    return _this4.arrangeList(data.predictions[loc].description);
                  }
                }, data.predictions[loc].description));
              };

              for (var loc = 0; loc < data.predictions.length; loc++) {
                _loop(loc);
              }
            } else if (data.state == "REQUEST_DENIED") {
              child.push(React.createElement("li", {
                className: _this4.state.liStyle
              }, data.error_message));
            } else {
              child.push(React.createElement("li", {
                className: _this4.state.liStyle
              }, "NO Result Found"));
            }

            var collection = React.createElement("ul", {
              className: 'style-unordered-list'
            }, child);

            _this4.setState({
              collection: collection,
              collectionShow: true
            });
          });
        }).catch(function (error) {
          _this4.setState({
            proxyUrl: proxyUrl
          });
        });
      } else {
        child.push(React.createElement("li", {
          className: this.state.liStyle
        }, "No Api Key Provided"));
        var collection = React.createElement("ul", {
          className: 'style-unordered-list'
        }, child);
        this.setState({
          collection: collection,
          collectionShow: true
        });
      }
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates(address) {
      var _this5 = this;

      if (this.props.apiKey) {
        var _fire = fetch(this.state.proxyUrl + 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=' + this.props.apiKey);

        return _fire.then(function (resp) {
          return resp.json().then(function (res) {
            return res;
          });
        }).catch(function (error) {
          _this5.setState({
            proxyUrl: proxyUrl
          });
        });
      }
    }
  }, {
    key: "getCurrentLocation",
    value: function getCurrentLocation() {
      var _this6 = this;

      if (this.props.apiKey) {
        navigator.geolocation.getCurrentPosition(function (location) {
          var obj = "latlng=" + location.coords.latitude + "," + location.coords.longitude;

          var _fire = fetch(_this6.state.proxyUrl + 'https://maps.googleapis.com/maps/api/geocode/json?' + obj + '&key=' + _this6.props.apiKey);

          return _fire.then(function (resp) {
            return resp.json().then(function (res) {
              _this6._returnData(res.results[0].formatted_address);

              _this6.setState({
                collectionShow: false
              });
            });
          }).catch(function (error) {
            _this6.setState({
              proxyUrl: proxyUrl
            });
          });
        });
      }
    }
  }, {
    key: "arrangeList",
    value: function arrangeList(place) {
      this._returnData(place);

      this.setState({
        collectionShow: false
      });
    }
  }, {
    key: "arrangeValue",
    value: function arrangeValue(item) {
      this.getInfo(item);
      this.setState({
        place: item
      });
      this.state.returnData.place = item;
      this.state.returnData.coordinates = "";

      if (this.props.onChange) {
        this.props.onChange(this.state.returnData);
      }
    }
  }, {
    key: "_returnData",
    value: function () {
      var _returnData2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(place) {
        var location;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  place: place
                });
                location = {};
                _context2.next = 4;
                return this.getCoordinates(place);

              case 4:
                location = _context2.sent;
                this.state.returnData.place = place;

                if (this.props.coordinates) {
                  if (location.status == 'OK') {
                    this.state.returnData.coordinates = location.results[0].geometry.location;
                  } else {
                    this.state.returnData.coordinates = "Error";
                  }
                } else {
                  this.state.returnData.coordinates = "Coordinates return false by props";
                }

                if (this.props.onChange) {
                  this.props.onChange(this.state.returnData);
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _returnData(_x) {
        return _returnData2.apply(this, arguments);
      }

      return _returnData;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      return React.createElement("div", {
        className: 'location-box-cover',
        ref: function ref(node) {
          return _this7.setWrapperRef(node);
        }
      }, React.createElement("input", {
        type: "text",
        className: this.props.locationBoxStyle ? this.props.locationBoxStyle : 'location-box',
        onChange: function onChange(e) {
          return _this7.arrangeValue(e.target.value);
        },
        placeholder: 'Start Typing Location',
        value: this.state.place,
        title: this.state.place
      }), this.state.collectionShow ? React.createElement("div", {
        className: "google-covert"
      }, this.state.currentLocation, this.state.collection) : null);
    }
  }]);

  return GoogleComponent;
}(Component);